/**
 * Форматирует дату в удобочитаемый вид
 */
export function formatDate(dateString: string): string {
  if (!dateString) return 'Не указана';
  
  const date = new Date(dateString);
  
  if (isNaN(date.getTime())) {
    return 'Неверная дата';
  }
  
  return date.toLocaleString('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

/**
 * Форматирует дату только до дня (без времени)
 */
export function formatDateOnly(dateString: string): string {
  if (!dateString) return 'Не указана';
  
  const date = new Date(dateString);
  
  if (isNaN(date.getTime())) {
    return 'Неверная дата';
  }
  
  return date.toLocaleDateString('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
}

/**
 * Возвращает относительное время (например, "2 часа назад")
 */
export function getRelativeTime(dateString: string): string {
  if (!dateString) return 'Не указана';
  
  const date = new Date(dateString);
  const now = new Date();
  
  if (isNaN(date.getTime())) {
    return 'Неверная дата';
  }
  
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  
  if (diffInSeconds < 60) {
    return 'Только что';
  }
  
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  
  if (diffInMinutes < 60) {
    return `${diffInMinutes} мин. назад`;
  }
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  
  if (diffInHours < 24) {
    return `${diffInHours} ч. назад`;
  }
  
  const diffInDays = Math.floor(diffInHours / 24);
  
  if (diffInDays < 7) {
    return `${diffInDays} дн. назад`;
  }
  
  return formatDateOnly(dateString);
}

/**
 * Форматирует валюту в удобочитаемый вид
 */
export function formatCurrency(amount: number): string {
  if (amount === null || amount === undefined) return '0 ₽';
  
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}

/** Доход / дебиторка в финансовых таблицах (Ant Design success) */
export const FORMAT_CURRENCY_INCOME_COLOR = '#52c41a';
/** Расход / кредиторка в финансовых таблицах (Ant Design error) */
export const FORMAT_CURRENCY_EXPENSE_COLOR = '#ff4d4f';